import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DiscountCol from './StyledDiscountCol'
import Image from '../../utils/StyledImage'
import DiscountLink from './StyledDiscountLink'
import UTM from '../../utils/UTM'
import ImageWrapper from './StyledImageWrapper'
import DiscountAmount from './StyledDiscountAmount'
import TitleWrapper from './StyledTitleWrapper'
import Title from './StyledTitle'
import MoreButton from './StyledMoreButton'

class DiscountBox extends Component {
  componentDidMount () {
    const {
      box: {
        guid: id,
        title: name,
        section: category
      },
      googleAnalytics,
      position
    } = this.props

    const impressionFieldObject = {
      id,
      name,
      category,
      list: 'slevydne',
      position
    }

    googleAnalytics.addImpression(impressionFieldObject)
  }

  handleAnchorClick (event, location) {
    event.preventDefault()

    const {
      box: {
        guid: id,
        title: name,
        section: category
      },
      googleAnalytics
    } = this.props

    const purchaseFieldObject = {
      id,
      name,
      category
    }

    googleAnalytics.handlePurchaseEvent(purchaseFieldObject).then(() => {
      document.location.href = location
    }).catch(() => {
      document.location.href = location
    })
  }

  render () {
    const {
      box,
      utmParams
    } = this.props

    const {
      discount,
      guid,
      image,
      imageClass,
      link,
      price,
      title
    } = box

    const utmLink = new UTM(link).getUTMLink(utmParams, false)

    return (
      <DiscountCol key={guid} sm={4}>
        <DiscountLink
          href={utmLink}
          onClick={event => this.handleAnchorClick(event, utmLink)}
        >
          <ImageWrapper>
            <Image src={image} alt={title} className={imageClass}/>
            {
              discount &&
              <DiscountAmount>
                -{ discount } %
              </DiscountAmount>
            }
          </ImageWrapper>
          <TitleWrapper>
            <Title>
              { title } za <span>{ price } Kč</span>
            </Title>
            <MoreButton>
              Zjistěte více
            </MoreButton>
          </TitleWrapper>
        </DiscountLink>
      </DiscountCol>
    )
  }
}

DiscountBox.propTypes = {
  box: PropTypes.object.isRequired,
  utmParams: PropTypes.object.isRequired,
  position: PropTypes.number.isRequired,
  googleAnalytics: PropTypes.object
}

export default DiscountBox
